export default "__VITE_ASSET__DqfMZgoa__"